module.exports = __webpack_public_path__ + "public/images/calendar-broadcast.3d95c0fcd68f5d0123820da9ec66d7c2.svg";